export enum QueryParamsActionType {
  Set = 'queryParams/SET_QUERY_PARAMS',
}
